module.exports = __webpack_public_path__ + "media/assets/images/category/YouRock@2x-3411bf6eb2a92d47bdfbcf2af38ffa24.png";